import * as Actions from '../actions/message.actions';

const initialState = {
	allMessages: null,
	loading: false,
};

export const messageReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case Actions.GET_ALL_MESSAGES:
			return (state = {
				...state,
				allMessages: payload,
			});
		case Actions.SEARCH_MESSAGES:
			return (state = {
				...state,
				allMessages: payload,
			});
		case Actions.LOADING_MESSAGES:
			return (state = {
				...state,
				loading: payload,
			});
		default:
			return state;
	}
};
